// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Images/auth/authbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
}

.App-container {
    max-width: 7570px;
    margin: auto;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    font-weight: 500 !important;
}

.btn-primary {
    background: rgb(41, 156, 219) !important;
}

/*** Authentification **/
.bg-image-auth {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    min-height: 100%;
    width: 50%;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* news */
.label {
    display: block;
    font-size: larger;
    color: white;
    padding: 5px;
}

.form {
    display: flex;
    padding-top: 90px;
    box-sizing: content-box;
    justify-content: center;
}

.messages {
    display: flex;
    justify-content: center;
}

.error {
    display: block;
    /* background-color: red; */
    color: red;
    width: fit-content;
    padding: 5px;
}

.success {
    display: block;
    background-color: lightblue;
    color: black;
    width: fit-content;
    height: 50px;
    padding: 5px;
}

/**** Sidebar collapse animation ******/
.sidebar {
    margin-left: -250px;
    transition: margin ease 0.5s;
}

.sidebar.open {
    margin: 0;
    z-index: 1;
}

.sidebar.open nav {
    position: fixed;
}

.sidebar nav {
    position: inherit;
}

.logonav.show {
    display: inherit;
    opacity: 1;
    transition: opacity ease 0.5s;
}

.logonav.hide {
    display: none;
    opacity: 0;
    transition: opacity ease 0.5s;
}

@media (max-width: 1300px) and (min-width: 768px) {
    .sidebar.open {
        margin-right: 20px !important;
    }
}

@media (max-width: 767px) {
    .sidebar.open {
        width: 100% !important;
        position: inherit;
    }

    .logonav.hide.logos {
        display: inherit;
        opacity: 1;
    }

    .sidebar.open nav,
    .sidebar.closed nav {
        max-width: 100% !important;
        position: fixed;
    }

    .logonav.show.blue,
    .logonav.hide.blue {
        display: inherit;
        opacity: 1;
        transition: opacity ease 0.5s;
    }

    .logonav.show.gray {
        display: none;
        opacity: 0;
        transition: opacity ease 0.5s;
    }

    .sidebar.closed {
        margin: 0;
        width: 100% !important;
        position: inherit;
        z-index: 1;
    }

    .sidebar.open.closed {
        margin-left: -100%;
        transition: margin ease 0.5s;
    }
}

/****** pagination ******/

.MuiTablePagination-selectLabel,
.MuiTablePagination-displayedRows {
    margin: 0;
}

.MuiTablePagination-root .MuiToolbar-root {
    overflow-y: scroll;
}

/**** Layout page *****/
.Layout.large {
    overflow: hidden;
}

@media (max-width: 991px) and (min-width: 909px) {
    .Layout.large nav.navbar {
        max-width: 82%;
    }
}

@media (max-width: 909px) and (min-width: 768px) {
    .Layout.large nav.navbar {
        max-width: 80%;
    }
}

/***** general basic styles *****/
table tr {
    height: 10px;
}

table thead th {
    font-weight: 500 !important;
}

table thead tr th {
    padding-block: 10px !important;
    /* padding-left: 0!important; */
}

table thead tr th:first-child,
table tbody tr th:first-child {
    padding-left: 1rem !important;
}

table tbody td:first-child {
    padding: 6px 16px !important;
}

tbody {
    overflow-y: auto;
    overflow-x: hidden;
}

table tr:nth-child(even) {
    background: #f5f5f5;
}

/**** btn *****/
.mapSwitchList {
    top: 50%;
    transform: translate(-100%, -50%);
    letter-spacing: 5px;
    position: fixed;
    /* transition: transform 0.8s ease; */
    z-index: 999;
    width: 50px;
    opacity: 0.6;
    left: 103%;
}

.App-container.px-2 .mapSwitchList.hided,
.App-container.px-4 .mapSwitchList.hided {
    transform: translate(0%, -50%);
    /* transition: transform 0.8s ease; */
    right: 0;
    opacity: 1;
    left: 98%;
}

.App-container.px-4 .mapSwitchList {
    left: 103%;
}

.mapSwitchList:hover {
    opacity: 1;
}

.mapSwitchList button {
    letter-spacing: 5px;
}

.hided.maps {
    margin-right: -200%;
    transition: margin-right ease-in-out 1s;
    opacity: 0;
    z-index: 0;
}

.normal.maps {
    margin-right: 0;
    transition: margin-right ease-in-out 1s;
    opacity: 1;
}

/**** Utility *****/
.pointer {
    cursor: pointer;
}

.accordionHeading.accordion-header button[aria-expanded="true"] {
    background: #fff;
    box-shadow: none;
    color: #282c34;
    outline: none;
    font-weight: 600;
}

.accordionHeading.accordion-header button[aria-expanded="false"] {
    background: #fff;
    color: #282c34;
    border-bottom: #5c5b5b72 solid 1px;
    border-radius: 0 !important;
    font-weight: 600;
}

@media (max-width: 767px) {
    .h-sm-auto {
        height: auto !important;
    }

    .h-sm-50 {
        height: 50px;
    }

    .h-sm-50 img.h-100 {
        height: auto !important;
    }
}

@media (max-width: 1024px) and (min-width: 768px) {
    .h-md-440 {
        height: 440px;
    }

    .h-md-440 img {
        object-fit: cover;
    }
}

@media (min-width: 576px) {
    .inscription-container .row {
        width: 774px;
    }
}

@media (max-width: 575.98px) {
    .inscription-container .row {
        width: 100%;
    }
}

@media (max-width: 575px) {
    .inscription-container {
        max-width: 500px;
        margin: auto;
    }

    .w-xs-normal {
        width: auto !important;
    }

    .h-md-440 {
        display: none;
    }

    .d-none-xs {
        display: none;
    }

    .h-sm-auto {
        height: 100vh !important;
    }
}

@media (max-width: 1199px) {
    .lg-screens,
    .lg-screens.hided {
        display: none;
    }

    .lg-screens.showed {
        display: block;
    }
}

/***** Forms *****/
.accordion.Filters label.form-label {
    color: #969696;
}

.accordion.Filters select {
    color: #5b5b5b;
}

.accordion.Filters .react-datepicker__input-container {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    appearance: none;
    border-radius: 0.375rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.accordion.Filters .react-datepicker-wrapper {
    margin-inline: 5px;
}

.accordion.Filters input::-webkit-outer-spin-button,
.accordion.Filters input::-webkit-inner-spin-button {
    /* Chrome, Safari, Edge, Opera */
    -webkit-appearance: none;
    margin: 0;
}

.accordion.Filters input[type="number"]::after {
    content: "m2";
}

/* Firefox */
.accordion.Filters input[type="number"] {
    -moz-appearance: textfield;
}

.accordion.Filters .react-datepicker__input-container input {
    border: none;
    color: #5b5b5b;
}

.transaction-heading.accordion-header .accordion-button {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
}

.transaction-heading.accordion-header .accordion-button::after {
    margin: 0;
}

/***** Table styles *****/
table tr td,
th {
    font-size: 0.9rem;
}

table tbody tr:hover {
    background: rgba(63, 80, 182, 0.1);
}

/**** Mui font styles *****/
h4.MuiTypography-root.MuiTypography-h4.css-5lbw0b-MuiTypography-root {
    font-size: 1.5rem;
}

h5.MuiTypography-root.MuiTypography-h5.css-ag7rrr-MuiTypography-root {
    font-size: 1.25rem;
}

.includedTabs .MuiTabs-flexContainer {
    height: 100% !important;
}

.includedTabs .MuiTabs-flexContainer .Mui-selected {
    color: #fff !important;
    background: #299cdb;
    border-top-right-radius: 8px;
}

/***** tabs *****/
@media (max-width: 899px) {
    .includedTabs .MuiTabs-flexContainer {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
}

/****exclude border ***/
.deleteBorder td {
    border: 0 solid !important;
    background: #d4ebf8;
}

/*** CRM ***/
.crm thead tr th:first-child {
    padding-left: 1rem !important;
}

.crm tbody tr {
    height: 52px !important;
}

.crm tbody tr:hover {
    background: rgba(63, 80, 182, 0.1) !important;
}

.crm tbody tr:nth-child(even) {
    background: #f5f5f5;
}

.email-list {
    width: 100%;
    padding-block: 0 !important;
}

.email-list li {
    padding: 0;
}

.email-list li div:first-child {
    width: auto;
    min-width: inherit;
}

.email-list div.MuiCollapse-root {
    margin-left: 35px;
}

/***** uploader styles ******/
.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
}

.styledDropBox .MuiDropzoneArea-root {
    min-height: 170px;
}

.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer p,
.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer svg {
    text-decoration: underline;
    color: #2196f3;
    font-size: 15px;
}

.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer p {
    margin-top: 0;
}

.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer svg {
    width: 30px;
    margin-top: 20px;
}

.styledSimpleDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    height: 45px;
}

.styledSimpleDropBox .MuiDropzoneArea-root {
    min-height: 50px;
    height: 50px;
}

.styledSimpleDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer p {
    font-size: 15px;
}

.styledSimpleDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer svg {
    color: #2196f3;
    width: 30px;
}

.styledSimpleDropBox {
    width: 48%;
}

/**** Affaires table *****/

.affaire_table tbody:nth-child(odd) {
    background: #f4fafd !important;
}

.affaire_table tbody:nth-child(even) {
    background: #fafafa;
}

.affaire_table tbody tr {
    background: none !important;
}

.affaire_table tbody .TacheCell.TacheCellWithBackground {
    background: #f4fafd !important;
}

.affaire_table tbody .TacheCell {
    background: #fafafa !important;
    padding-bottom: 40px !important;
    padding-inline: 26px !important;
}

/***** Taches table *****/
.TacheCell .MuiAccordionSummary-root {
    flex-direction: row-reverse;
}

.TacheCell .MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper {
    width: fit-content !important;
    justify-content: center;
}

/* .TacheCell .MuiCollapse-root *:not(.excludeStyles *) , .TacheCell .MuiCollapse-root {
  width:100%!important;
} */
.TacheCell .MuiCollapse-root .excludedStyles {
    margin: initial;
}

/**** notes *****/
.noteCordion {
    justify-content: space-between;
    align-items: center;
    display: flex;
    padding: 15px;
    flex-wrap: wrap;
}

/**** toast ****/
.Toastify__toast-container--top-right {
    z-index: 999999 !important;
}

/**** Résumé parcelle ****/
.resume {
    position: fixed;
    top: 0;
    height: 100vh;
    width: 450px;
    z-index: 99999;
    transition: transform ease-in-out 0.5s;
}

.resume .inner {
    height: 100%;
    overflow: scroll;
}

.resume.open {
    right: 0;
    transform: translateX(0%);
    transition: transform ease-in-out 0.5s;
}

.resume.closed {
    right: 0;
    transform: translateX(100%);
    transition: transform ease-in-out 0.5s;
}

@media (max-width: 500px) and (min-width: 380px) {
    .resume {
        max-width: 320px;
        width: 100%;
    }
}

@media (max-width: 380px) {
    .resume {
        max-width: 292px;
        width: 100%;
    }
}

/*** MUI overlays: menus must remain above modal dialogs ***/
.MuiModal-root {
    z-index: 1300;
}

.MuiPopover-root,
.MuiMenu-root {
    z-index: 1500;
}

/* Style pour le popup de couleur */
[data-popup-position="right"] .color-picker-popup {
    position: absolute;
    left: 100%;
    top: 0;
    margin-left: 10px;
    z-index: 1000;
}

/*** animation scroll ***/
.slide-panel {
    position: fixed;
    top: 70px;
    right: 21px;
    background: white;
    padding: 20px;
    max-width: 440px;
    width: 100%;
    z-index: 999999;

    /* Animation de base */
    transform: translateX(100%);
    opacity: 0;
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-panel-open {
    transform: translateX(0);
    opacity: 1;
}

.slide-panel-closed {
    transform: translateX(100%);
    opacity: 0;
}

/*** Maps & Tags ***/
.isActived {
    background: rgba(25, 118, 210, 0.04) !important;
}

/*** stickie's heading ***/
.list-fixed-heading {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1000;
    padding: 10px 0;
    margin-bottom: 10px
}

/* Fix thead on scroll for all tables */
.crm thead tr,
.users-table thead tr,
.tags-table thead tr,
.parcelles-table, .transactions-table {
    position: sticky;
    top: 0;
    background: #eeeeee;
    z-index: 1000;
}

.crm thead th,
.users-table thead th,
.tags-table thead th,
.parcelles-table th, .transactions-table th {
    background: #eeeeee;
    position: sticky;
    top: 0;
    z-index: 1000;
}

/* Ensure table container has proper scroll */
.overflow-auto,
.table-container {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
}

/* Add shadow to thead when sticky */
.crm thead tr.sticky,
.users-table thead tr.sticky,
.tags-table thead tr.sticky,
.parcelles-table.sticky {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* MapBox canvas style fix */
.mapboxgl-canvas {
    width: 100% !important;
}

/***** all checkbox *****/
.form-check-input:checked {
    background-color: #1B208C !important;
    border-color: #0d6efd;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,wBAAwB;AACxB;IACI,yDAAsD;IACtD,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,SAAS;AACT;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;;QAEI,0BAA0B;QAC1B,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,UAAU;QACV,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,UAAU;QACV,6BAA6B;IACjC;;IAEA;QACI,SAAS;QACT,sBAAsB;QACtB,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;IAChC;AACJ;;AAEA,yBAAyB;;AAEzB;;IAEI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,iCAAiC;AACjC;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,QAAQ;IACR,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,8BAA8B;IAC9B,qCAAqC;IACrC,QAAQ;IACR,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,UAAU;IACV,UAAU;AACd;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;QAEI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,kBAAkB;AAClB;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,wEAAwE;AAC5E;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,gCAAgC;IAChC,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA,yBAAyB;AACzB;;IAEI,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA,iBAAiB;AACjB;IACI;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;AACJ;;AAEA,uBAAuB;AACvB;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,0BAA0B;IAC1B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA,0BAA0B;;AAE1B;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA,yBAAyB;AACzB;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;;GAEG;AACH;IACI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,0BAA0B;AAC9B;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,MAAM;IACN,aAAa;IACb,YAAY;IACZ,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,QAAQ;IACR,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA,4DAA4D;AAC5D;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,iBAAiB;IACjB,aAAa;AACjB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,eAAe;;IAEf,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,+CAA+C;AACnD;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA,uCAAuC;AACvC;;;;IAII,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;;;IAII,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,aAAa;AACjB;;AAEA,6CAA6C;AAC7C;;IAEI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;;;;IAII,wCAAwC;AAC5C;;AAEA,4BAA4B;AAC5B;IACI,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,oCAAoC;IACpC,qBAAqB;AACzB","sourcesContent":[".App {\n    text-align: center;\n}\n\n.App-container {\n    max-width: 7570px;\n    margin: auto;\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {\n    font-weight: 500 !important;\n}\n\n.btn-primary {\n    background: rgb(41, 156, 219) !important;\n}\n\n/*** Authentification **/\n.bg-image-auth {\n    background-image: url(./assets/Images/auth/authbg.png);\n    background-size: cover;\n    min-height: 100%;\n    width: 50%;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* news */\n.label {\n    display: block;\n    font-size: larger;\n    color: white;\n    padding: 5px;\n}\n\n.form {\n    display: flex;\n    padding-top: 90px;\n    box-sizing: content-box;\n    justify-content: center;\n}\n\n.messages {\n    display: flex;\n    justify-content: center;\n}\n\n.error {\n    display: block;\n    /* background-color: red; */\n    color: red;\n    width: fit-content;\n    padding: 5px;\n}\n\n.success {\n    display: block;\n    background-color: lightblue;\n    color: black;\n    width: fit-content;\n    height: 50px;\n    padding: 5px;\n}\n\n/**** Sidebar collapse animation ******/\n.sidebar {\n    margin-left: -250px;\n    transition: margin ease 0.5s;\n}\n\n.sidebar.open {\n    margin: 0;\n    z-index: 1;\n}\n\n.sidebar.open nav {\n    position: fixed;\n}\n\n.sidebar nav {\n    position: inherit;\n}\n\n.logonav.show {\n    display: inherit;\n    opacity: 1;\n    transition: opacity ease 0.5s;\n}\n\n.logonav.hide {\n    display: none;\n    opacity: 0;\n    transition: opacity ease 0.5s;\n}\n\n@media (max-width: 1300px) and (min-width: 768px) {\n    .sidebar.open {\n        margin-right: 20px !important;\n    }\n}\n\n@media (max-width: 767px) {\n    .sidebar.open {\n        width: 100% !important;\n        position: inherit;\n    }\n\n    .logonav.hide.logos {\n        display: inherit;\n        opacity: 1;\n    }\n\n    .sidebar.open nav,\n    .sidebar.closed nav {\n        max-width: 100% !important;\n        position: fixed;\n    }\n\n    .logonav.show.blue,\n    .logonav.hide.blue {\n        display: inherit;\n        opacity: 1;\n        transition: opacity ease 0.5s;\n    }\n\n    .logonav.show.gray {\n        display: none;\n        opacity: 0;\n        transition: opacity ease 0.5s;\n    }\n\n    .sidebar.closed {\n        margin: 0;\n        width: 100% !important;\n        position: inherit;\n        z-index: 1;\n    }\n\n    .sidebar.open.closed {\n        margin-left: -100%;\n        transition: margin ease 0.5s;\n    }\n}\n\n/****** pagination ******/\n\n.MuiTablePagination-selectLabel,\n.MuiTablePagination-displayedRows {\n    margin: 0;\n}\n\n.MuiTablePagination-root .MuiToolbar-root {\n    overflow-y: scroll;\n}\n\n/**** Layout page *****/\n.Layout.large {\n    overflow: hidden;\n}\n\n@media (max-width: 991px) and (min-width: 909px) {\n    .Layout.large nav.navbar {\n        max-width: 82%;\n    }\n}\n\n@media (max-width: 909px) and (min-width: 768px) {\n    .Layout.large nav.navbar {\n        max-width: 80%;\n    }\n}\n\n/***** general basic styles *****/\ntable tr {\n    height: 10px;\n}\n\ntable thead th {\n    font-weight: 500 !important;\n}\n\ntable thead tr th {\n    padding-block: 10px !important;\n    /* padding-left: 0!important; */\n}\n\ntable thead tr th:first-child,\ntable tbody tr th:first-child {\n    padding-left: 1rem !important;\n}\n\ntable tbody td:first-child {\n    padding: 6px 16px !important;\n}\n\ntbody {\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\ntable tr:nth-child(even) {\n    background: #f5f5f5;\n}\n\n/**** btn *****/\n.mapSwitchList {\n    top: 50%;\n    transform: translate(-100%, -50%);\n    letter-spacing: 5px;\n    position: fixed;\n    /* transition: transform 0.8s ease; */\n    z-index: 999;\n    width: 50px;\n    opacity: 0.6;\n    left: 103%;\n}\n\n.App-container.px-2 .mapSwitchList.hided,\n.App-container.px-4 .mapSwitchList.hided {\n    transform: translate(0%, -50%);\n    /* transition: transform 0.8s ease; */\n    right: 0;\n    opacity: 1;\n    left: 98%;\n}\n\n.App-container.px-4 .mapSwitchList {\n    left: 103%;\n}\n\n.mapSwitchList:hover {\n    opacity: 1;\n}\n\n.mapSwitchList button {\n    letter-spacing: 5px;\n}\n\n.hided.maps {\n    margin-right: -200%;\n    transition: margin-right ease-in-out 1s;\n    opacity: 0;\n    z-index: 0;\n}\n\n.normal.maps {\n    margin-right: 0;\n    transition: margin-right ease-in-out 1s;\n    opacity: 1;\n}\n\n/**** Utility *****/\n.pointer {\n    cursor: pointer;\n}\n\n.accordionHeading.accordion-header button[aria-expanded=\"true\"] {\n    background: #fff;\n    box-shadow: none;\n    color: #282c34;\n    outline: none;\n    font-weight: 600;\n}\n\n.accordionHeading.accordion-header button[aria-expanded=\"false\"] {\n    background: #fff;\n    color: #282c34;\n    border-bottom: #5c5b5b72 solid 1px;\n    border-radius: 0 !important;\n    font-weight: 600;\n}\n\n@media (max-width: 767px) {\n    .h-sm-auto {\n        height: auto !important;\n    }\n\n    .h-sm-50 {\n        height: 50px;\n    }\n\n    .h-sm-50 img.h-100 {\n        height: auto !important;\n    }\n}\n\n@media (max-width: 1024px) and (min-width: 768px) {\n    .h-md-440 {\n        height: 440px;\n    }\n\n    .h-md-440 img {\n        object-fit: cover;\n    }\n}\n\n@media (min-width: 576px) {\n    .inscription-container .row {\n        width: 774px;\n    }\n}\n\n@media (max-width: 575.98px) {\n    .inscription-container .row {\n        width: 100%;\n    }\n}\n\n@media (max-width: 575px) {\n    .inscription-container {\n        max-width: 500px;\n        margin: auto;\n    }\n\n    .w-xs-normal {\n        width: auto !important;\n    }\n\n    .h-md-440 {\n        display: none;\n    }\n\n    .d-none-xs {\n        display: none;\n    }\n\n    .h-sm-auto {\n        height: 100vh !important;\n    }\n}\n\n@media (max-width: 1199px) {\n    .lg-screens,\n    .lg-screens.hided {\n        display: none;\n    }\n\n    .lg-screens.showed {\n        display: block;\n    }\n}\n\n/***** Forms *****/\n.accordion.Filters label.form-label {\n    color: #969696;\n}\n\n.accordion.Filters select {\n    color: #5b5b5b;\n}\n\n.accordion.Filters .react-datepicker__input-container {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    appearance: none;\n    border-radius: 0.375rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.accordion.Filters .react-datepicker-wrapper {\n    margin-inline: 5px;\n}\n\n.accordion.Filters input::-webkit-outer-spin-button,\n.accordion.Filters input::-webkit-inner-spin-button {\n    /* Chrome, Safari, Edge, Opera */\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.accordion.Filters input[type=\"number\"]::after {\n    content: \"m2\";\n}\n\n/* Firefox */\n.accordion.Filters input[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n.accordion.Filters .react-datepicker__input-container input {\n    border: none;\n    color: #5b5b5b;\n}\n\n.transaction-heading.accordion-header .accordion-button {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.transaction-heading.accordion-header .accordion-button::after {\n    margin: 0;\n}\n\n/***** Table styles *****/\ntable tr td,\nth {\n    font-size: 0.9rem;\n}\n\ntable tbody tr:hover {\n    background: rgba(63, 80, 182, 0.1);\n}\n\n/**** Mui font styles *****/\nh4.MuiTypography-root.MuiTypography-h4.css-5lbw0b-MuiTypography-root {\n    font-size: 1.5rem;\n}\n\nh5.MuiTypography-root.MuiTypography-h5.css-ag7rrr-MuiTypography-root {\n    font-size: 1.25rem;\n}\n\n.includedTabs .MuiTabs-flexContainer {\n    height: 100% !important;\n}\n\n.includedTabs .MuiTabs-flexContainer .Mui-selected {\n    color: #fff !important;\n    background: #299cdb;\n    border-top-right-radius: 8px;\n}\n\n/***** tabs *****/\n@media (max-width: 899px) {\n    .includedTabs .MuiTabs-flexContainer {\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n    }\n}\n\n/****exclude border ***/\n.deleteBorder td {\n    border: 0 solid !important;\n    background: #d4ebf8;\n}\n\n/*** CRM ***/\n.crm thead tr th:first-child {\n    padding-left: 1rem !important;\n}\n\n.crm tbody tr {\n    height: 52px !important;\n}\n\n.crm tbody tr:hover {\n    background: rgba(63, 80, 182, 0.1) !important;\n}\n\n.crm tbody tr:nth-child(even) {\n    background: #f5f5f5;\n}\n\n.email-list {\n    width: 100%;\n    padding-block: 0 !important;\n}\n\n.email-list li {\n    padding: 0;\n}\n\n.email-list li div:first-child {\n    width: auto;\n    min-width: inherit;\n}\n\n.email-list div.MuiCollapse-root {\n    margin-left: 35px;\n}\n\n/***** uploader styles ******/\n.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n}\n\n.styledDropBox .MuiDropzoneArea-root {\n    min-height: 170px;\n}\n\n.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer p,\n.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer svg {\n    text-decoration: underline;\n    color: #2196f3;\n    font-size: 15px;\n}\n\n.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer p {\n    margin-top: 0;\n}\n\n.styledDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer svg {\n    width: 30px;\n    margin-top: 20px;\n}\n\n.styledSimpleDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px;\n    height: 45px;\n}\n\n.styledSimpleDropBox .MuiDropzoneArea-root {\n    min-height: 50px;\n    height: 50px;\n}\n\n.styledSimpleDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer p {\n    font-size: 15px;\n}\n\n.styledSimpleDropBox .MuiDropzoneArea-root .MuiDropzoneArea-textContainer svg {\n    color: #2196f3;\n    width: 30px;\n}\n\n.styledSimpleDropBox {\n    width: 48%;\n}\n\n/**** Affaires table *****/\n\n.affaire_table tbody:nth-child(odd) {\n    background: #f4fafd !important;\n}\n\n.affaire_table tbody:nth-child(even) {\n    background: #fafafa;\n}\n\n.affaire_table tbody tr {\n    background: none !important;\n}\n\n.affaire_table tbody .TacheCell.TacheCellWithBackground {\n    background: #f4fafd !important;\n}\n\n.affaire_table tbody .TacheCell {\n    background: #fafafa !important;\n    padding-bottom: 40px !important;\n    padding-inline: 26px !important;\n}\n\n/***** Taches table *****/\n.TacheCell .MuiAccordionSummary-root {\n    flex-direction: row-reverse;\n}\n\n.TacheCell .MuiAccordionSummary-root .MuiAccordionSummary-expandIconWrapper {\n    width: fit-content !important;\n    justify-content: center;\n}\n\n/* .TacheCell .MuiCollapse-root *:not(.excludeStyles *) , .TacheCell .MuiCollapse-root {\n  width:100%!important;\n} */\n.TacheCell .MuiCollapse-root .excludedStyles {\n    margin: initial;\n}\n\n/**** notes *****/\n.noteCordion {\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    padding: 15px;\n    flex-wrap: wrap;\n}\n\n/**** toast ****/\n.Toastify__toast-container--top-right {\n    z-index: 999999 !important;\n}\n\n/**** Résumé parcelle ****/\n.resume {\n    position: fixed;\n    top: 0;\n    height: 100vh;\n    width: 450px;\n    z-index: 99999;\n    transition: transform ease-in-out 0.5s;\n}\n\n.resume .inner {\n    height: 100%;\n    overflow: scroll;\n}\n\n.resume.open {\n    right: 0;\n    transform: translateX(0%);\n    transition: transform ease-in-out 0.5s;\n}\n\n.resume.closed {\n    right: 0;\n    transform: translateX(100%);\n    transition: transform ease-in-out 0.5s;\n}\n\n@media (max-width: 500px) and (min-width: 380px) {\n    .resume {\n        max-width: 320px;\n        width: 100%;\n    }\n}\n\n@media (max-width: 380px) {\n    .resume {\n        max-width: 292px;\n        width: 100%;\n    }\n}\n\n/*** MUI overlays: menus must remain above modal dialogs ***/\n.MuiModal-root {\n    z-index: 1300;\n}\n\n.MuiPopover-root,\n.MuiMenu-root {\n    z-index: 1500;\n}\n\n/* Style pour le popup de couleur */\n[data-popup-position=\"right\"] .color-picker-popup {\n    position: absolute;\n    left: 100%;\n    top: 0;\n    margin-left: 10px;\n    z-index: 1000;\n}\n\n/*** animation scroll ***/\n.slide-panel {\n    position: fixed;\n    top: 70px;\n    right: 21px;\n    background: white;\n    padding: 20px;\n    max-width: 440px;\n    width: 100%;\n    z-index: 999999;\n\n    /* Animation de base */\n    transform: translateX(100%);\n    opacity: 0;\n    transition: transform 0.5s ease, opacity 0.5s ease;\n}\n\n.slide-panel-open {\n    transform: translateX(0);\n    opacity: 1;\n}\n\n.slide-panel-closed {\n    transform: translateX(100%);\n    opacity: 0;\n}\n\n/*** Maps & Tags ***/\n.isActived {\n    background: rgba(25, 118, 210, 0.04) !important;\n}\n\n/*** stickie's heading ***/\n.list-fixed-heading {\n    position: sticky;\n    top: 0;\n    background-color: white;\n    z-index: 1000;\n    padding: 10px 0;\n    margin-bottom: 10px\n}\n\n/* Fix thead on scroll for all tables */\n.crm thead tr,\n.users-table thead tr,\n.tags-table thead tr,\n.parcelles-table, .transactions-table {\n    position: sticky;\n    top: 0;\n    background: #eeeeee;\n    z-index: 1000;\n}\n\n.crm thead th,\n.users-table thead th,\n.tags-table thead th,\n.parcelles-table th, .transactions-table th {\n    background: #eeeeee;\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n}\n\n/* Ensure table container has proper scroll */\n.overflow-auto,\n.table-container {\n    max-height: calc(100vh - 300px);\n    overflow-y: auto;\n}\n\n/* Add shadow to thead when sticky */\n.crm thead tr.sticky,\n.users-table thead tr.sticky,\n.tags-table thead tr.sticky,\n.parcelles-table.sticky {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* MapBox canvas style fix */\n.mapboxgl-canvas {\n    width: 100% !important;\n}\n\n/***** all checkbox *****/\n.form-check-input:checked {\n    background-color: #1B208C !important;\n    border-color: #0d6efd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
